export function RestResourceService($http, SessionService) {
  function request(method, resource, params, successCallback, errorCallback) {
    if (typeof $http[method] === 'function') {
      if (method !== 'get') {
        var currentUser = SessionService.getCurrentUser();

        if (
          SessionService.isLoggedIn() &&
          SessionService.getSelectedAccountCompany() &&
          !currentUser.sd
        ) {
          // isLoggedIn to prevent not logged users
          params.audit_company_id = SessionService.getSelectedAccountCompany().id;
        }
      }

      // Verify the request type, to send the params as json object in POST case.
      var paramsData = method === 'post' || method === 'put' ? params : { params: params };

      return $http[method](resource, paramsData).then(
        function (response) {
          // Updates LocalStorage
          if (response.data) {
            if (response.data.user_info) {
              var currentUser = SessionService.getCurrentUser();
              currentUser.user_info = response.data.user_info;

              // Updates cu
              SessionService.setCurrentUser('cu', currentUser);

              var company = currentUser.user_info.companies.find(
                (company) => company.id === SessionService.getSelectedAccountCompany().id
              );

              SessionService.setSelectedAccountCompany(company, true);
            }
          }

          // console.log(response);

          return successCallback(response);
        },
        function (response) {
          // TODO: fix this
          if (errorCallback !== undefined) {
            return errorCallback(response);
          }

          // return false;
        }
      );
    }
  }

  return {
    request: request,
  };
}

RestResourceService.$inject = ['$http', 'SessionService'];

// var company = SessionService.findCompanyInCompanies(
//   currentUser.user_info.companies,
//   'id',
//   SessionService.getSelectedAccountCompany().id
// );
